<template>
    <div class="home">
        <dataRange @maxTime="getMaxTime" @minTime="getMinTime" :out_defaultMinTime=out_defaultMinTime :out_defaultMaxTime=out_defaultMaxTime :out_bounceMinTime=out_bounceMinTime :out_bounceMaxTime=out_bounceMaxTime></dataRange>
        <tree></tree>
    </div>
</template>
<script>
// 时间滑块测试demo
import dataRange from '@/components/dataRange';
import tree from"@/../plugins/tree/src/tree";
export default {
    data() {
        return {
            out_defaultMinTime: ['2011','5','11'],
            out_defaultMaxTime: ['2012','1','11'],
            out_bounceMinTime: ['2010','0','1'],
            out_bounceMaxTime: ['2019','0','1']
        };
    },
    components:{
        dataRange,
        tree
    },
    methods: {
        getMaxTime(val){
            console.log(val,'val111')
        },
        getMinTime(val){
            console.log(val,'val222')
        }
        
    },
    mounted() {
       
    },
  
};
</script>
<style scoped lang="less">
.home {
  width: 100vw;
  height: 100vh;
}

</style>


// WEBPACK FOOTER //
// src/view/login/test.vue